module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "shaded m-5",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.save.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-9 name-min-height-error"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.$v.form.name.$invalid
    }
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                        Name "), _c('span', {
    staticClass: "brand"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.form.name.$invalid) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.form.name.required) ? _c('span', [_vm._v("Name is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.form.name.minLength) ? _c('span', [_vm._v("Name must have at least 3 characters.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.form.name.repeatName) ? _c('span', [_vm._v("This name already exists. Service name should be unique")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.getShowInvoiceOption) ? _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.billingProductIdTooltip),
      expression: "billingProductIdTooltip"
    }],
    staticClass: "full"
  }, [_vm._v("\n                        Billing Product ID\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.code),
      expression: "form.code"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "code", $event.target.value)
      }
    }
  })])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Service type")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.componentTypesOptions
    },
    on: {
      "input": function($event) {
        return _vm.setComponentType(_vm.componentTypeObject.componentType)
      }
    },
    model: {
      value: (_vm.componentTypeObject),
      callback: function($$v) {
        _vm.componentTypeObject = $$v
      },
      expression: "componentTypeObject"
    }
  })], 1)]), _vm._v(" "), _c('h5', {
    staticClass: "mt-4"
  }, [_vm._v("PRICES - PVP")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row mb-4"
  }, [(_vm.taxes) ? _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Tax")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.taxes,
      "placeholder": "- Select tax -",
      "label": "description"
    },
    on: {
      "input": _vm.updateVatTypes
    },
    model: {
      value: (_vm.selectedVatType),
      callback: function($$v) {
        _vm.selectedVatType = $$v
      },
      expression: "selectedVatType"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 d-flex align-items-center mt-3"
  }, [_c('checkbox', {
    model: {
      value: (_vm.form.prices[0].priceIncludeTaxes),
      callback: function($$v) {
        _vm.$set(_vm.form.prices[0], "priceIncludeTaxes", $$v)
      },
      expression: "form.prices[0].priceIncludeTaxes"
    }
  }, [_vm._v("\n                    Price with taxes\n                ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_vm._l((_vm.form.prices), function(price, index) {
    return _c('div', {
      staticClass: "row mb-2 price-min-height-error"
    }, [_c('div', {
      staticClass: "col-sm-2"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "d-flex"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (price.value),
        expression: "price.value"
      }],
      staticClass: "glued-right w-100",
      class: {
        'border-color-6': _vm.$v.form.prices.$each[index].value.$invalid
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (price.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(price, "value", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "glued-left",
      class: {
        'color-6': _vm.$v.form.prices.$each[index].value.$invalid
      }
    }, [_vm._v("€")])]), _vm._v(" "), _c('div', {
      staticClass: "color-6"
    }, [(_vm.$v.form.prices.$each[index].value.$invalid) ? _c('div', {
      staticClass: "error messages"
    }, [_c('span', [_vm._v("Price is required")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-8 pl-5"
    }, [_vm._m(1, true), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (price.name),
        expression: "price.name"
      }],
      class: {
        'border-color-6': _vm.$v.form.prices.$each[index].name.$invalid
      },
      attrs: {
        "type": "text",
        "placeholder": "PVP Name"
      },
      domProps: {
        "value": (price.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(price, "name", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "color-6"
    }, [(_vm.$v.form.prices.$each[index].name.$invalid) ? _c('div', {
      staticClass: "error messages"
    }, [_c('span', [_vm._v("Label is required")])]) : _vm._e()])]), _vm._v(" "), (_vm.form.prices.length > 1) ? _c('div', {
      staticClass: "col-sm-2 d-flex align-items-center justify-content-end"
    }, [_c('div', {
      staticClass: "row mr-1"
    }, [_c('i', {
      staticClass: "ico ico-delete m-0 fs-large medium pointer",
      on: {
        "click": function($event) {
          return _vm.removePrice(index)
        }
      }
    })])]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "add d-flex align-items-center pointer fs-small bold my-3"
  }, [_c('span', {
    on: {
      "click": _vm.addPrice
    }
  }, [_c('i', {
    staticClass: "ico-add fs-smallest add-circle color-1"
  }), _vm._v(" New PVP\n                    ")])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Additional description\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.description),
      expression: "form.description"
    }],
    attrs: {
      "placeholder": "e.g. Alert for high temperatures."
    },
    domProps: {
      "value": (_vm.form.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "italic fs-smaller dark mt-2"
  }, [_vm._v("This message is public and is shown on the booking screen.")])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('h5', [_vm._v("Service status")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center w-100"
  }, [_c('span', {
    staticClass: "fs-small bold mr-2"
  }, [_vm._v("Service is active:")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "labels": {
        checked: 'Yes',
        unchecked: 'No'
      },
      "disabled": false
    },
    model: {
      value: (_vm.form.isActive),
      callback: function($$v) {
        _vm.$set(_vm.form, "isActive", $$v)
      },
      expression: "form.isActive"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "full"
  }, [_vm._v("\n                            Price "), _c('span', {
    staticClass: "brand"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "full"
  }, [_vm._v("\n                            Label\n                            "), _c('span', {
    staticClass: "brand"
  }, [_vm._v("*")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-ea7b9ede", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea7b9ede"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/extras/ExtraForm.vue
// module id = 1530
// module chunks = 0